@if (editableImage()) {
    <web-image-settings [form]="form" (saveEvent)="editImage(null)" (cancelEvent)="cancelImageSettings()" />
} @else {
    <web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" />

    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div [class.mb-20]="image()">
                <sp-file-manager
                    [fmSourceType]="fmSourceType.LANDING"
                    [file]="image()"
                    [displayOnly]="[DirectoryItemCategory.Image]"
                    (setFileEvent)="setImage($event)"
                    (replaceFileEvent)="replaceImage($event)"
                >
                    @if (!image()) {
                        <sp-defautl-upload-button
                            stockImagesDropdown
                            [disabled]="buttonDisabled()"
                            (unsplashRequested)="openUnsplashModal()"
                        />
                    }

                    <ng-template
                        #previewTemplate
                        let-file="file"
                        let-replaceFileFn="replaceFileFn"
                        let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                    >
                        <div class="mb-20">
                            <sp-files-select
                                #ref
                                toggless
                                (myPhotosClick)="replaceFileFn()"
                                (unsplashClick)="openUnsplashModal()"
                            >
                                <sp-control-handle
                                    [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                    [controlHandleMainText]="file.name"
                                    [controlHandleSubText]="imageSubText()"
                                    (editActionEvent)="editImage(file)"
                                    (removeActionEvent)="removeFile()"
                                    (replaceActionEvent)="ref.dp.toggle()"
                                />
                            </sp-files-select>
                        </div>
                    </ng-template>
                </sp-file-manager>
            </div>

            @if (image()) {
                <div>
                    <div class="form-group mb-20">
                        <label class="col-xs-6 control-label">
                            {{ "control_width" | translate }}
                            <small [tooltip]="imageWidth" class="sp-icon icon-info-bold color-light"> </small>
                            <ng-template #imageWidth>
                                {{ "img_control_max_width" | translate }}
                            </ng-template>
                        </label>
                        <div class="col-xs-6 img-width-control">
                            <sp-input-num
                                suffixText="px"
                                [min]="1"
                                [max]="imageNaturalWidth()"
                                [value]="maxWidth()"
                                (valueChange)="setMaxWidth($event)"
                            />
                        </div>
                    </div>

                    <div class="mt-20">
                        <web-custom-id
                            [displayId]="form?.displayId()"
                            (valueChangeEvent)="form?.setDisplayId($event)"
                        />
                    </div>
                </div>
            }
        </div>
    </div>
}
